@import '../../scss/mixin';

.indicator {
  position: absolute;
  top: 50%;
  left: 4px;
  margin-top: -16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  pointer-events: none;

  &.streaming {
    animation: llmRotate 4s linear infinite;
    animation-delay: 0.2s;
  }
}

.icon {
  width: 32px;
  height: 32px;
  background-image: url("https://design.wslabs.it/llm-ernestomeda-test/assets/ai.gif");
  background-size: 100%;
  background-repeat: no-repeat;
}

@keyframes llmRotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
